import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CfetBaseComponent } from '../../cfet-core';

@Component({
    selector: 'app-complete-profile-utf',
    templateUrl: './complete-profile-utf.component.html',
    styleUrls: ['./complete-profile-utf.component.scss'],
    standalone: false
})
export class CompleteProfileUtfComponent extends CfetBaseComponent implements OnInit {

  constructor(private title: Title) { super(); }

  ngOnInit() {
    this.title.setTitle(this.cfetTitles.success.utfHtmlTitle);
  }

}
